export const LegalTypeEnum = {
  IMPRINT: 'imprint',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_OF_SERVICE: 'terms-of-service',
} as const

export type LegalTypeEnum = (typeof LegalTypeEnum)[keyof typeof LegalTypeEnum]
